




































































































import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import { update_agency_invoice } from '@/api/invoice';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'InvoiceAgencyDetailOperationSupervisorConfirm',
})
export default class InvoiceAgencyDetailOperationSupervisorConfirm extends Vue {
  public static readonly invoiceAgencyOperationSupervisorConfirmEvent =
    'invoice-agency-operation-supervisor-confirm';
  @Prop({ default: true }) flat!: boolean;
  @Prop({ default: false }) loading!: boolean;
  private valid = false;
  private operator = '';
  private operatorRules: ((v: string) => boolean | string)[] = [];
  private note = '';
  private dialog = false;
  private dialogConfirmHandler = this.resetDialog;
  private dialogTextTitle = '';
  private dialogTextFooter = '';

  get isDialogFullscreen() {
    return false && this.$vuetify.breakpoint.smAndDown;
  }

  get canSupervisorConfirm() {
    return this.valid;
  }

  get canSupervisorConfirmReject() {
    return this.valid;
  }

  mounted() {
    this.loadDefaultOperatedBy();
    this.loadRules();
  }

  private loadDefaultOperatedBy() {
    this.operator = UserModule.defaultOperatedBy;
  }

  private loadRules() {
    this.operatorRules = [
      (v: string) =>
        !!v ||
        (this.$t('{msg} is required', {
          msg: this.$t('Operated by'),
        }) as string),
    ];
  }

  private resetDialog() {
    this.dialog = false;
    this.dialogTextTitle = '';
    this.dialogTextFooter = '';
    this.$nextTick(() => {
      this.dialogConfirmHandler = this.resetDialog;
    });
  }

  private showDialogForReset() {
    this.dialogTextTitle = `${this.$t('Reset')}`;
    this.dialogTextFooter = `${this.$t('Is it OK?')}`;
    this.dialogConfirmHandler = () => {
      this.resetDialog();
      this.reset();
    };
    this.dialog = true;
  }

  private showDialogForSupervisorConfirm() {
    this.dialogTextTitle = `${this.$t(
      'InvoiceOperationEnum.INVOICE_SUPERVISOR_CONFIRM'
    )}`;
    this.dialogTextFooter = `${this.$t('Is it OK?')}`;
    this.dialogConfirmHandler = () => {
      this.resetDialog();
      this.supervisorConfirm();
    };
    this.dialog = true;
  }

  private showDialogForSupervisorConfirmReject() {
    this.dialogTextTitle = `${this.$t(
      'InvoiceOperationEnum.INVOICE_SUPERVISOR_CONFIRM_REJECT'
    )}`;
    this.dialogTextFooter = `${this.$t('Is it OK?')}`;
    this.dialogConfirmHandler = () => {
      this.resetDialog();
      this.supervisorConfirmReject();
    };
    this.dialog = true;
  }

  private reset() {
    (this.$refs.form as any).reset();
  }

  private supervisorConfirm() {
    this.$emit(
      InvoiceAgencyDetailOperationSupervisorConfirm.invoiceAgencyOperationSupervisorConfirmEvent,
      {
        operatorName: this.operator,
        supervisorConfirm: {
          reject: false,
        },
        note: this.note,
      } as Partial<update_agency_invoice.Request>
    );
  }

  private supervisorConfirmReject() {
    this.$emit(
      InvoiceAgencyDetailOperationSupervisorConfirm.invoiceAgencyOperationSupervisorConfirmEvent,
      {
        operatorName: this.operator,
        supervisorConfirm: {
          reject: true,
        },
        note: this.note,
      } as Partial<update_agency_invoice.Request>
    );
  }
}
